'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = ['file'];

var LOCAL_ID = exports.LOCAL_ID = ['localId'];

var FILE_ID = exports.FILE_ID = ['fileId'];

var UPLOAD_PROGRESS = exports.UPLOAD_PROGRESS = ['uploadProgress'];